const {Vue, jQuery: $} = window;

import {
	convertName,
	launchConfigurator,
	leadFormData,
	getOptionsMatrixRegionId
} from "../_utilities";
import {
	socialShare,
} from "../_social-share";
import { ACTIONS } from "../_actions";
import {store, store$} from "../_config-store";
import { localize } from "../_localize.js";

const dataReady$ = store$
	.map(state => state.dataReady);

const optionInteracted$ = store$
	.map(state => state.optionInteracted);

const activeOption$ = store$
	.map(state => state.activeOption);

const activeOptionChildren$ = store$
	.map(state => state.activeOptionChildren);

const optionsInView$ = store$
	.map(state => state.optionsInView);

const viewOptions$ = store$
	.map(state => state.viewOptions);

const truckCab$ = store$
	.map(state => state.truckCab);

const summaryActive$ = store$
	.map(state => state.summaryActive);

const quoteDisabled$ = store$
	.map(state => state.quoteDisabled);

export const options = {
	template:
	`<transition-group name="slide" tag="div" id="dialog-overlay" v-if="dataReady" v-bind:data-viewer="view">
		<div key="dealer-brand" v-if="showBranding && dealer && !activeOption && !summaryActive" dealer-brand><a v-bind:href="'http://'+dealer.Website" target="_blank">{{dealer.Group || dealer.Name}}</a> <a v-if="!dealer.Group" v-bind:href="'tel:'+dealer.Phone">{{dealer.Phone}}</a></div>
		<button back @click="back" v-if="!activeOption" key="back" v-bind:data-cab="local(truckCab)">{{local('Back to Cab Types')}}</button>
		<div help v-if="!interacted && !activeOption && ['interior','exterior'].indexOf(view) !== -1" key="rotate">{{local('Click and Drag to Rotate Truck')}}</div>
		
		<div actions key="optionquote" v-if="!summaryActive && activeOption && windowWidth >= 768 && interacted">
			<button @click="cancel" cancel key="cancel">{{local('Cancel')}}</button>
			<button v-if="activeOptionChildren && Object.keys(activeOptionChildren).length" @click="next" next key="next">{{local('Next')}}</button>
			<button v-else @click="select" select key="select">{{local('Select')}}</button>
			<button quote @click="getQuote" key="quote">{{summaryLabel}}</button>
		</div>
		<div actions key="optionnoquote" v-else-if="!summaryActive && activeOption && (!interacted || windowWidth < 768) ">
			<button @click="cancel" cancel key="cancel">{{local('Cancel')}}</button>
			<button v-if="activeOptionChildren && Object.keys(activeOptionChildren).length" @click="next" next key="next">{{local('Next')}}</button>
			<button v-else @click="select" select key="select">{{local('Select')}}</button>
		</div>
		<div actions key="quoteonly" v-else-if="!summaryActive && !activeOption && (interacted || windowWidth < 768) ">
			<button quote @click="getQuote" key="quote">{{summaryLabel}}</button>
		</div>

		<div v-else-if="summaryActive" actions key="summary">
			<button @click="edit" edit key="edit">{{local('Edit')}}</button>
			<button v-if="local('Share').trim()" :disabled="quoteDisabled" @click="share" share key="share">{{local('Share')}}</button>
		</div> 

		<div key="warn" v-if="warning" warn>{{warning}}</div>
		<div key="brand" v-if="!activeOption" brand :region="region"></div>
	</transition-group>`,
	props: ['view'],
	data() {
		return {
			showBranding: false,
			leadForm: leadFormData(),
			windowWidth: this.getWindowWidth(),
			brokenInteriors: {
				// '116" BBC 60" XT':true,
				// '116" BBC 60" RR':true,
				// '126" BBC 60" XT':true,
				// '126" BBC 60" RR':true,
				// '126" BBC 72" XT':true,
				// '116" BBC 72" XT':true,
			},
			local(str){
				return str;
			}
		}
	},
	subscriptions() {
		return {
			dataReady: dataReady$,
			optionInteracted: optionInteracted$,
			activeOption: activeOption$,
			activeOptionChildren: activeOptionChildren$,
			optionsInView: optionsInView$,
			viewOptions: viewOptions$,
			summaryActive: summaryActive$,
			truckCab: truckCab$,
			quoteDisabled: quoteDisabled$,
		}
	},
	mounted() {
		this.$nextTick(() => {
			window.addEventListener('resize', () => {
				this.windowWidth = this.getWindowWidth();
			} );
		});
	},
	computed: {
		interacted(){
			return Object.keys(this.optionInteracted).length > 0;
		},
		dealer(){
			return (window.dealers || [])[0];
		},
		region(){
			return getOptionsMatrixRegionId();
		},
		summaryLabel() {
			// ADHOC METHOD TO CHANGE BUTTON TEXT IF HIDEFORM IS TRUE
			if (window.hideForm === 'True') {
				return this.local('View Summary');
			} else {
				return this.leadForm ? this.leadForm.SubmitLabel : this.local('Get a Quote');
			}
		},
		warning(){
			//return 'VIEW: ' + this.view + ' REG: ' + (this.dealer ? this.dealer.OptionsMatrixRegionId : 1);
			return this.view ==='interior' && this.brokenInteriors[this.truckCab] ? 
					local('Updated images coming soon') :
				this.view ==='interior' && [2].find( item => (this.region).toString() === item.toString() ) ?
					'La tableta Zonar no está disponible fuera de Estados Unidos y Canadá' :
				false;
		}
	},
	methods: {
		optionSelect() {

			(
				this.optionsInView[0].options ?
				this.optionsInView :
				[{label: this.activeOption, currentKey: _.chain(this.optionsInView).find( item => item.attributes && item.attributes.checked ).at('attributes["data-key"]').value().join('') }]
			)
			.forEach( (option) => {
				store.dispatch({
					type: ACTIONS.OPTION_SELECT,
					cat: option.label,
					option: option.currentKey
				});
			});

		},
		cancel(){
			store.dispatch({
				type: ACTIONS.ACTIVE_OPTION_CHANGE,
				data: ''
			});
			store.dispatch({
				type: ACTIONS.BUILD_SETTINGS_RESTORE
			});
		},
		select(){
			this.optionSelect();
			store.dispatch({
				type: ACTIONS.OPTION_INTERACTED
			});
			store.dispatch({
				type: ACTIONS.ACTIVE_OPTION_CHANGE,
				data: ''
			});
			store.dispatch({
				type: ACTIONS.BUILD_SETTINGS_BACKUP_CLEAR
			});
		},
		next(){
			this.optionSelect();
			store.dispatch({
				type: ACTIONS.SET_CHILDREN_ACTIVE,
				data: true
			});
		},
		getQuote() {
			let option = this.viewOptions[_.findIndex(this.viewOptions,{id: 'misc'})];
			if(option){
				store.dispatch({
					type: ACTIONS.VIEW_OPTION_CHANGE,
					data: option.name
				});
			}

			store.dispatch({
				type: ACTIONS.ACTIVE_SUMMARY_CHANGE,
				data: true
			});

            window.history.pushState({
                type: ACTIONS.ACTIVE_SUMMARY_CHANGE,
                data: false
            }, `Edit`, ``);
            window.history.pushState({
                type: ACTIONS.VIEW_OPTION_CHANGE,
                data: option.name
            }, `Misc`, ``);
				
		},
		back(){
			$("body").removeClass("configurator-open");
			$("#configurator").removeClass("open");
			store.dispatch({
				type: ACTIONS.CAB_RESET
			});
		},
		edit() {
			let option = this.viewOptions[_.findIndex(this.viewOptions,{id: 'exterior'})];
			store.dispatch({
				type: ACTIONS.ACTIVE_SUMMARY_CHANGE,
				data: false
			});
			if(option){
				store.dispatch({
					type: ACTIONS.VIEW_OPTION_CHANGE,
					data: option.name
				});
			}
		},
		share() {
			const data = leadFormData();
			if (data.Fields) {
				const token = data.Fields.find(x => x.key === 'X-CSRF-TOKEN-FTL');
				if (token) {
					socialShare('facebook', { 'X-CSRF-TOKEN-FTL': token.value });
					return;
				}
			}
			
			console.error('Unauthorized. No token exists.');
		},
		getWindowWidth(event) {
			return document.documentElement.clientWidth;
		},
	},
	updated() {
		window.getComputedStyle(this.$el);
	},
	created(){
		localize().then( local => this.local = local );
	}
}


Vue.component('dialog-overlay',options);